import HeroSection from "@/components/HeroSection";
import UploadSection from "@/components/UploadSection";
import HowItWorks from "@/components/HowItWorks";
import FAQSection from "@/components/FAQSection";
import { Zap } from "lucide-react";

export default function Landing() {
  const scrollToUpload = () => {
    const el = document.getElementById("upload");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="landing-page">
      <HeroSection onStartClick={scrollToUpload} />
      <UploadSection />
      <HowItWorks />
      <FAQSection />
      <FooterCta />
      <Footer />
    </div>
  );
}

function FooterCta() {
  return (
    <section className="border-t border-slate-200 bg-white" data-testid="footer-cta">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-12 py-20 text-center">
        <h3 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
          Klaar om je energiecontract te ontrafelen?
        </h3>
        <p className="mt-3 text-slate-600 max-w-xl mx-auto">
          Gratis. Anoniem. Binnen 30 seconden weet je wat je leverancier niet zegt.
        </p>
        <a
          href="#upload"
          className="inline-block mt-8 bg-blue-700 hover:bg-blue-800 text-white font-medium rounded-lg px-7 py-3.5 shadow-sm transition-all hover:-translate-y-0.5"
          data-testid="footer-cta-btn"
        >
          Check je contract nu
        </a>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 py-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
        <div className="flex items-center gap-2">
          <div className="h-7 w-7 rounded-lg bg-blue-700 text-white grid place-items-center">
            <Zap className="h-4 w-4" />
          </div>
          <span className="font-heading font-bold text-slate-900">EnergieKontract</span>
        </div>
        <div>
          © {new Date().getFullYear()} EnergieKontract · Eerlijke energiecontract analyse · Geen juridisch bindend advies
        </div>
      </div>
    </footer>
  );
}
